import { useEffect, useState } from "react";
import { Download, Share, X } from "lucide-react";
import { Button } from "@/components/ui/button";

let deferredPrompt = null;
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferredPrompt = e; window.dispatchEvent(new Event("pwa-installable")); });
}

export function InstallAppButton() {
  const [canInstall, setCanInstall] = useState(!!deferredPrompt);
  const [iosHint, setIosHint] = useState(false);
  const standalone = typeof window !== "undefined" && (window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone);
  const isIOS = typeof navigator !== "undefined" && /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;
  useEffect(() => {
    const on = () => setCanInstall(true);
    window.addEventListener("pwa-installable", on);
    window.addEventListener("appinstalled", () => setCanInstall(false));
    return () => window.removeEventListener("pwa-installable", on);
  }, []);
  if (standalone) return null;
  const install = async () => {
    if (deferredPrompt) { deferredPrompt.prompt(); await deferredPrompt.userChoice; deferredPrompt = null; setCanInstall(false); return; }
    setIosHint(true);
  };
  if (!canInstall && !isIOS) return null;
  return (
    <div className="px-3 pb-2">
      <Button variant="outline" className="w-full justify-start rounded-xl border-primary/40 text-primary" onClick={install} data-testid="install-app-btn"><Download className="h-4 w-4 mr-2" /> Install as App</Button>
      {iosHint && (
        <div className="mt-2 rounded-xl bg-muted p-3 text-xs relative" data-testid="ios-install-hint">
          <button type="button" className="absolute top-2 right-2" onClick={() => setIosHint(false)}><X className="h-3.5 w-3.5" /></button>
          Tap <Share className="inline h-3.5 w-3.5 mx-0.5" /> <b>Share</b> in Safari, then <b>Add to Home Screen</b>.
        </div>
      )}
    </div>
  );
}
